import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Image from 'gatsby-image';
import vars from '../lib/styled';
import { ButtonLink, ButtonLinkExternal } from '../components/Button';

const CardWrapper = styled.article`
    display: flex;
    flex-direction: ${props => props.right ? 'row-reverse' : 'row'};
    margin-bottom: 2rem;
    position: relative;
    width: 100%;
    z-index: 1;

    @media (max-width: ${vars.breakpoint.tablet}){
        display: block;
    }
`;

const CardBodyColumn = styled.div`
    flex: .75;
    margin: 4rem 0;
    position: relative;
    z-index: 1;

    @media (max-width: ${vars.breakpoint.tablet}){
        margin: 0;
    }
`;

const CardBody = styled.div`
    background-color: ${vars.contrast};
    box-shadow: ${vars.boxShadow};
    border-radius: ${vars.borderRadius};
    padding: 3rem 8rem 3rem 4rem;
    
    @media (max-width: ${vars.breakpoint.laptop}){
        padding-right: 4rem;
    }

    @media (max-width: ${vars.breakpoint.tablet}){
        padding: 2rem;
    }
`;

const CardMedia = styled.figure`
    flex: 1;
    margin: 0;
    position: relative;

    .gatsby-image-wrapper {
        left: 0;
        position: absolute !important;
        top: 0;
    }

    @media (max-width: ${vars.breakpoint.tablet}){
        height: 350px;
        margin: 0 !important;
    }   

    ${props => props.right
        ? css`
            margin-left: -4rem;
            @media (max-width: ${vars.breakpoint.laptop}){
                margin-left: -5rem;
            }  
        `
        : css`
            margin-right: -4rem;
            @media (max-width: ${vars.breakpoint.laptop}){
                margin-right: -5rem;
            }    
        `
    }
`;

export const CardHeading = styled.h2`
    font-size: 2.027em;
    margin-top: .5rem;
`;

export const CardSubHeading = styled.p`
    font-size: 1.125em;
    margin: 0;
`;

const CardKitchen = ({
    subtitle,
    title,
    url,
    button,
    image,
    body,
    inverse
}) => {
    const isExternal = url.startsWith('http');
    const isMail = url.includes('@');

    return (
        <CardWrapper right={inverse}>
            <CardMedia right={inverse}>
                {image && (
                    <Image
                        fluid={image.fluid}
                        alt={image.title}
                        style={{ height: '100%', width: '100%' }}
                    />
                )}
            </CardMedia>
            <CardBodyColumn>
                <CardBody>
                    <CardHeading>{title}</CardHeading>
                    <div>
                        {body && (
                            <div dangerouslySetInnerHTML={{
                                __html: body.childContentfulRichText.html
                            }} />
                        )}
                    </div>
                    {url && (
                        <div>
                            {(isExternal || isMail)
                                ? (
                                    <ButtonLinkExternal href={isMail ? `mailTo:${url}` : url}>
                                        {button}
                                    </ButtonLinkExternal>
                                )
                                : (
                                    <ButtonLink to={url}>
                                        {button}
                                    </ButtonLink>
                                )
                            }
                        </div>
                    )}
                </CardBody>
            </CardBodyColumn>
        </CardWrapper>
    );
};

CardKitchen.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    button: PropTypes.string,
    image: PropTypes.shape({
        title: PropTypes.string,
        fluid: PropTypes.object
    }).isRequired,
    body: PropTypes.shape({
        childContentfulRichText: PropTypes.object
    }).isRequired,
    inverse: PropTypes.bool
};

CardKitchen.defaultProps = {
    button: 'Learn More',
    inverse: false,
    url: '/'
};

export default CardKitchen;
